import { ArticleResolution } from '@wix/answers-api';
import React from 'react';

import { ArticleSearchResultItem, VoteType } from '../types';

export const useVoteType = (article: ArticleSearchResultItem) => {
  const voteType = React.useMemo(() => {
    if (article.resolution === ArticleResolution.COLLECTING_VOTES) {
      return VoteType.VOTE;
    }
    return VoteType.FOLLOW;
  }, [article.resolution]);

  return voteType;
};
